import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-loading"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "content"
}
const _hoisted_4 = { class: "heading" }
const _hoisted_5 = { class: "heading-row" }
const _hoisted_6 = { class: "title-content" }
const _hoisted_7 = ["actions"]
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "number-cards" }
const _hoisted_10 = {
  class: "dashboard-card",
  variant: "info"
}
const _hoisted_11 = { slot: "title" }
const _hoisted_12 = { class: "number-text" }
const _hoisted_13 = { class: "number" }
const _hoisted_14 = {
  class: "dashboard-card",
  variant: "info"
}
const _hoisted_15 = { slot: "title" }
const _hoisted_16 = { class: "number-text" }
const _hoisted_17 = { class: "number" }
const _hoisted_18 = {
  class: "dashboard-card",
  variant: "info"
}
const _hoisted_19 = { slot: "title" }
const _hoisted_20 = { class: "number-text" }
const _hoisted_21 = { class: "number" }
const _hoisted_22 = {
  key: 0,
  class: "mt-20"
}
const _hoisted_23 = {
  key: 1,
  class: "deployment"
}
const _hoisted_24 = { class: "simple-box-row app-instances" }
const _hoisted_25 = {
  variant: "info",
  class: "dashboard-card simple-box"
}
const _hoisted_26 = {
  slot: "title",
  class: "consumption-card"
}
const _hoisted_27 = { class: "instances" }
const _hoisted_28 = ["value", "total"]
const _hoisted_29 = { class: "instances-controls" }
const _hoisted_30 = ["disabled"]
const _hoisted_31 = {
  key: 1,
  class: "scale-instances__spinner mt-5"
}
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "deployment__origin__row" }
const _hoisted_34 = {
  key: 1,
  class: "stats-table"
}
const _hoisted_35 = { class: "mt-15" }
const _hoisted_36 = {
  key: 0,
  variant: "info",
  class: "dashboard-card simple-box"
}
const _hoisted_37 = {
  slot: "title",
  class: "deployment__origin__list"
}
const _hoisted_38 = { class: "origin-prop" }
const _hoisted_39 = { class: "origin-value" }
const _hoisted_40 = { class: "origin-prop" }
const _hoisted_41 = {
  key: 0,
  class: "origin-value"
}
const _hoisted_42 = ["href"]
const _hoisted_43 = {
  key: 1,
  class: "origin-value"
}
const _hoisted_44 = ["href"]
const _hoisted_45 = {
  key: 2,
  class: "origin-value"
}
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { class: "origin-prop" }
const _hoisted_48 = { class: "origin-value" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "origin-prop" }
const _hoisted_51 = { class: "origin-value" }
const _hoisted_52 = { class: "origin-prop" }
const _hoisted_53 = { class: "origin-value" }
const _hoisted_54 = ["rows", "columns"]
const _hoisted_55 = { class: "mt-20" }
const _hoisted_56 = ["rows"]
const _hoisted_57 = { class: "search-container" }
const _hoisted_58 = ["value"]
const _hoisted_59 = ["rows", "total-items", "current-page", "loading"]
const _hoisted_60 = { class: "search-container" }
const _hoisted_61 = ["value"]
const _hoisted_62 = ["rows", "total-items", "current-page", "loading"]

import { ref, computed, watch, Ref } from 'vue';
import { useStore } from 'vuex';
import day from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { formatSi } from '@shell/utils/units';
import { EPINIO_TYPES } from '../types';
import Tabs from '../components/application/Tabs.vue';
import Banner from '@components/Banner/Banner.vue';
import {
  makeStateTag,
  makeActionMenu,
  makeCommitShaCell,
  makeCommitAuthorCell,
} from '../utils/table-formatters';
import ServiceInstanceModal from '../components/service/ServiceInstanceModal.vue';
import ServiceDeleteModal from '../components/service/ServiceDeleteModal.vue';
import ConfigurationModal from '../components/configuration/ConfigurationModal.vue';
import ConfigurationDeleteModal from '../components/configuration/ConfigurationDeleteModal.vue';
import AppModal from '../components/application/AppModal.vue';
import ExportAppModal from '../dialog/ExportAppModal.vue';
import AppDeleteModal from '../components/application/AppDeleteModal.vue';
import { useApplication } from '../queries/useApplicationQueries';
import { toInstanceStats, toAppSourceDetails, toAppForm } from '../models/application/mappers';
import { ListResourceRequestParams, ResourceQueryOptions, ResourceTableRow } from '../models/resource/ui-types';
import { ServiceInstance } from '../models/service/ui-types';
import { ConfigurationResponse } from '../models/configuration/ui-types';
import { AppUpdateRequest } from '../models/application/ui-types';
import { GitProxyGitRepo, GitProxyGitBranch, GitProxyGitCommit } from '../models/gitproxy/ui-types';
import { debounce } from 'lodash';
import { useNamespacedServices } from '../queries/useServiceQueries';
import { useNamespacedConfigurations } from '../queries/useConfigurationQueries';
import { useUser } from '../queries/useUserQueries';
import { App, AppForm, AppPodInfo } from '../models/application/ui-types';
import { showAppShell } from '../models/application/actions/shell';
import { showAppLog, showStagingLog } from '../models/application/actions/logs';
import { restageApp, restartApp } from '../models/application/actions/restage';
import { makeNameLinks, makeEmptyCell } from '../utils/table-formatters';
import { useUpdateApplication } from '../queries/useApplicationMutations';
import { useGitConfig } from '../queries/useGitConfigQueries';
import { useGitBaseUrl, useGitProxyUserType, useGitProxyRepos, useGitProxyBranches, useGitProxyCommits } from '../queries/useGitProxyQueries';


export default /*@__PURE__*/_defineComponent({
  __name: 'applications',
  setup(__props) {

day.extend(relativeTime);

const store = useStore();
const router = store.$router;
const route = store.$router.currentRoute.value;
const t = store.getters['i18n/t'];

// Application modals
const appModal = ref<InstanceType<typeof AppModal> | null>(null);
const exportAppModal = ref<InstanceType<typeof ExportAppModal> | null>(null);
const appDeleteModal = ref<InstanceType<typeof AppDeleteModal> | null>(null);

// Service modals
const serviceModal = ref<InstanceType<typeof ServiceInstanceModal> | null>(null);
const serviceDeleteModal = ref<InstanceType<typeof ServiceDeleteModal> | null>(null);

// Configuration modals
const configModal = ref<InstanceType<typeof ConfigurationModal> | null>(null);
const configDeleteModal = ref<InstanceType<typeof ConfigurationDeleteModal> | null>(null);

// Fetch user for permissions
const { data: user } = useUser(store);

// Fetch application details
const appRequestOptions = ref<ResourceQueryOptions>({
  enabled: true,
  polling: true,
  isTablePagination: false,
});
const { data: application, isLoading: isApplicationLoading, isError: isApplicationError, error: applicationError, refetch: refetchApplication } = useApplication(store, route.params.namespace as string, route.params.id as string, appRequestOptions);

// Convert app to form data for easy access
const appFormData = computed<AppForm | null>(() => {
  if (!application.value) {
    return null;
  }
  return toAppForm(application.value);
});

// Tab configuration
const activeDeploymentTab = ref<string | number>('overview');
const deploymentTabs = computed(() => [
  {
    id: 'overview',
    label: t('epinio.applications.detail.tables.overview'),
    completed: false,
    valid: true,
    disabled: false,
    visible: true
  },
  {
    id: 'gitCommits',
    label: t('epinio.applications.detail.tables.gitCommits'),
    completed: false,
    valid: true,
    disabled: false,
    visible: !!application.value?.origin.git?.revision,
  }
])
const activeResourceTab = ref<string | number>('instances');
const resourceTabs = ref([
  {
    id: 'instances',
    label: t('epinio.applications.detail.tables.instances'),
    completed: false,
    valid: true,
    disabled: false,
    visible: true,
  },
  {
    id: 'services',
    label: t('epinio.applications.detail.tables.services'),
    completed: false,
    valid: true,
    disabled: false,
    visible: true,
  },
  {
    id: 'configs',
    label: t('epinio.applications.detail.tables.configs'),
    completed: false,
    valid: true,
    disabled: false,
    visible: true,
  }
]);

// Fetch services for table
const servicesRequestParams = ref<ListResourceRequestParams>({
  page: 1,
  pageSize: 10,
  search: '',
  app: route.params.id as string,
});
const requestOptions = ref<ResourceQueryOptions>({
  enabled: true,
  polling: true,
  isTablePagination: true,
});
const servicesSearchQuery = ref<string>('');
watch(servicesSearchQuery, (newQuery) => {
  onServicesSearch(newQuery);
});
const onServicesSearch = debounce(async (query: string) => {
  servicesRequestParams.value.page = 1;
  servicesRequestParams.value.search = query;
}, 500);
const {data: services, isLoading: isLoadingServices} = useNamespacedServices(store, route.params.namespace as string, servicesRequestParams, requestOptions);

// Fetch configurations for table
const configurationsRequestParams = ref<ListResourceRequestParams>({
  page: 1,
  pageSize: 10,
  search: '',
  app: route.params.id as string,
});
const configurationsSearchQuery = ref<string>('');
watch(configurationsSearchQuery, (newQuery) => {
  onConfigurationsSearch(newQuery);
});
const onConfigurationsSearch = debounce(async (query: string) => {
  configurationsRequestParams.value.page = 1;
  configurationsRequestParams.value.search = query;
}, 500);
const {data: configurations, isLoading: isLoadingConfigurations} = useNamespacedConfigurations(store, route.params.namespace as string, configurationsRequestParams, requestOptions);

// Update app mutation for increasing/decreasing instances
const { mutateAsync: updateApp, isPending: isUpdatingApp } = useUpdateApplication(store, () => refetchApplication());

// Permissions for various app actions
const canEditApp = computed(() => {
  return user.value?.permissions?.app_update || user.value?.permissions?.app_write || user.value?.permissions?.app;
});
const canDeleteApp = computed(() => {
  return user.value?.permissions?.app_delete || user.value?.permissions?.app_write || user.value?.permissions?.app;
});
const canExportApp = computed(() => {
  return user.value?.permissions?.app_export || user.value?.permissions?.app_write || user.value?.permissions?.app;
});
const canExecApp = computed(() => {
  return user.value?.permissions?.app_exec  || user.value?.permissions?.app;
});
const canLogsApp = computed(() => {
  return user.value?.permissions?.app_logs || user.value?.permissions?.app;
});
const canStageApp = computed(() => {
  return user.value?.permissions?.app_stage || user.value?.permissions?.app_write || user.value?.permissions?.app;
});
const canRestartApp = computed(() => {
  return user.value?.permissions?.app_restart || user.value?.permissions?.app_write || user.value?.permissions?.app;
});
const canScaleApp = computed(() => {
  return user.value?.permissions?.app_scale || user.value?.permissions?.app_write || user.value?.permissions?.app;
});

// Application actions for display in the top right action menu
const openEditAppModal = (app: App) => {
  appModal.value?.openEdit(app);
};
const openDeleteAppModal = (app: App) => {
  appDeleteModal.value?.openDelete(app);
};
const appAvailableActions = computed(() => {
  if (!application.value) return [];
  return [{
    label: 'App Shell',
    action: () => showAppShell(store, application.value),
    enabled: canExecApp.value && application.value.status === 'running',
    visible: canExecApp.value,
  }, {
    label: 'App Logs',
    action: () => showAppLog(store, application.value),
    enabled: canLogsApp.value && (application.value.status === 'running' || application.value.status === 'error'),
    visible: canLogsApp.value,
  }, {
    label: 'Last Build Logs',
    action: () => showStagingLog(store, application.value),
    enabled: canLogsApp.value && !!application.value.stageId,
    visible: canLogsApp.value,
  }, {
    label: 'Export',
    action: () => exportAppModal.value?.openExport(application.value),
    enabled: canExportApp.value && application.value.status === 'running',
    visible: canExportApp.value,
  }, {
    label: 'Restage',
    action: () => restageApp(store, application.value),
    enabled: canStageApp.value && application.value.canRetryBuild,
    visible: canStageApp.value,
  }, {
    label: 'Restart',
    action: () => restartApp(store, application.value),
    enabled: canRestartApp.value && application.value.status === 'running',
    visible: canRestartApp.value,
  }, {
    label: 'Edit',
    action: () => openEditAppModal(application.value),
    enabled: canEditApp.value,
    visible: canEditApp.value,
  }, {
    label: 'Delete',
    action: () => openDeleteAppModal(application.value),
    enabled: canDeleteApp.value,
    visible: canDeleteApp.value,
    danger: true,
  }];
});

// Columns for the instances table
const instanceColumns = [
  {
    field: 'stateDisplay',
    label: 'State',
    width: '100px',
    formatter: (_v: any, row: any) => makeStateTag(row)
  },
  {
    field: 'name',
    label: 'Name',
    formatter: (_v: any, row: AppPodInfo) => {
      const nameText = document.createElement('p');
      nameText.textContent = row.name;
      nameText.style.whiteSpace = 'normal';
      nameText.style.wordBreak = 'break-word';
      return nameText;
    }
  },
  {
    field: 'millicpus',
    label: 'Mill CPUs',
    formatter: (value: unknown, row: AppPodInfo) => formatMetricValue(value, row)
  },
  {
    field: 'memoryBytes',
    label: 'RAM',
    formatter: (value: unknown, row: AppPodInfo) => {
      if (row.metricsOk === false) {
        return t('epinio.intro.metrics.notAvailableShort');
      }

      return formatSi(value, { suffix: 'iB', firstSuffix: 'B', increment: 1024 });
    }
  },
  {
    field: 'restarts',
    label: 'Restarts'
  },
  {
    field: 'createdAt',
    label: 'Age',
    formatter: 'age'
  }
];

const instanceRows = computed(() => {
  if (!application.value?.deployment?.replicas) {
    return [];
  }

  return (Object.values(application.value.deployment.replicas)).map((i) => ({
    ...i,
    status: i.ready ? 'ready' : 'not-ready',
    stateDisplay: i.ready ? 'Ready' : 'Not Ready'
  }));
});

// Columns for the services table
const serviceColumns = [
  {
    field: 'stateDisplay',
    label: 'State',
    width: '100px',
    formatter: (_v: any, row: ServiceInstance) => makeStateTag(row)
  },
  {
    field: 'nameDisplay',
    label: 'Name',
    formatter: (_v: any, row: ServiceInstance) => {
      const el = document.createElement('a');

      el.textContent = row.meta?.name || '';
      el.style.cursor = 'pointer';
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        serviceModal.value?.openView(row);
      });

      return el;
    }
  },
  {
    field: 'catalogService',
    label: 'Catalog Service',
    sortable: false,
    formatter: (_v: any, row: ServiceInstance) => makeNameLinks(
      [row.catalogService],
      { cluster: store.getters['clusterId'], resource: EPINIO_TYPES.CATALOG_SERVICE },
      router
    )
  },
  {
    field: 'catalogServiceVersion',
    label: 'Catalog Service Version'
  },
  {
    field: 'meta.createdAt',
    label: 'Age',
    formatter: 'age'
  }
];

// Service actions and display logic
const canEditService = computed(() => {
  return user.value?.permissions?.service_write || user.value?.permissions?.service;
});
const canDeleteService = canEditService;
const openDeleteServiceModal = (service: ServiceInstance) => {
  serviceDeleteModal.value?.openDelete(service);
};
const openEditServiceModal = (service: ServiceInstance) => {
  serviceModal.value?.openEdit(service);
};
const displayServiceRows = computed(() => {
  if (!services.value) {
    return [];
  }

  // Add custom namespace delete action to replace the built in rancher shell flow.
  // Gate by namespace write perms so view-only / app-only roles don't see Delete.
  const rows: ResourceTableRow<ServiceInstance>[] = (services.value.items ?? []).map((s) => ({
    ...s,
    id: s.meta.name, // stable, unique per namespace
    availableActions: [
      {
        label: 'Edit',
        action: () => openEditServiceModal(s),
        enabled: canEditService.value,
        visible: canEditService.value,
      },
      {
        label: 'Delete',
        action: () => openDeleteServiceModal(s),
        enabled: canDeleteService.value,
        visible: canDeleteService.value,
        danger: true,
      },
    ],
    canDelete: canDeleteService.value,
  }));
  return rows;
});

// Columns for the configurations table
const configurationColumns = [
  {
    field: 'nameDisplay',
    label: 'Name',
    width: '200px',
    formatter: (_v: any, row: ConfigurationResponse) => {
      const el = document.createElement('a');

      el.textContent = row.meta?.name || '';
      el.style.cursor = 'pointer';
      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        configModal.value?.openView(row);
      });

      return el;
    }
  },
  {
    field: 'configuration.origin',
    label: 'Service',
    width: '150px',
    sortable: false,
  },
  {
    field: 'configuration.variableCount',
    label: 'No. of Variables',
    width: '150px'
  },
  {
    field: 'configuration.user',
    label: 'Created By',
    width: '150px',
    formatter: (_v: any, row: ConfigurationResponse) => row.configuration?.user || makeEmptyCell()
  },
  {
    field: 'meta.createdAt',
    label: 'Age',
    width: '50px',
    formatter: 'age'
  }
];

// Configuration actions and display logic
const canEditConfiguration = computed(() => {
  return user.value?.permissions?.service_write || user.value?.permissions?.service;
});
const canDeleteConfiguration = canEditConfiguration;
const openDeleteConfigurationModal = (configuration: ConfigurationResponse) => {
  configDeleteModal.value?.openDelete(configuration);
};
const openEditConfigurationModal = (configuration: ConfigurationResponse) => {
  configModal.value?.openEdit(configuration);
};
const displayConfigurationRows = computed(() => {
  if (!configurations.value) {
    return [];
  }

  // Add custom namespace delete action to replace the built in rancher shell flow.
  // Gate by namespace write perms so view-only / app-only roles don't see Delete.
  const rows: ResourceTableRow<ConfigurationResponse>[] = (configurations.value.items ?? []).map((c) => ({
    ...c,
    id: c.meta.name, // stable, unique per namespace
    availableActions: [
      {
        label: 'Edit',
        action: () => openEditConfigurationModal(c),
        enabled: canEditConfiguration.value && !c.configuration.origin,
        visible: canEditConfiguration.value && !c.configuration.origin,
      },
      {
        label: 'Delete',
        action: () => openDeleteConfigurationModal(c),
        enabled: canDeleteConfiguration.value,
        visible: canDeleteConfiguration.value,
        danger: true,
      },
    ],
    canDelete: canDeleteConfiguration.value,
  }));
  return rows;
});

// Data handling for instance metrics
const showMetricsUnavailable = computed(() => {
  const replicas = application.value?.deployment?.replicas ?? {};
  const hasReplicas = Object.keys(replicas).length > 0;
  const allReplicasMetricsOk = hasReplicas ?
    Object.values(replicas).every((r) => r.metricsOk) : false;
  return !allReplicasMetricsOk;
});
function formatMetricValue(value: unknown, row: { metricsOk?: boolean }) {
  if (row.metricsOk === false) {
    return t('epinio.intro.metrics.notAvailableShort');
  }

  return value;
}
const instanceMemory = computed(() => {
    const stats = toInstanceStats(Object.values(application.value?.deployment?.replicas ?? {}), 'memoryBytes');
    const opts = {
      suffix:      'iB',
      firstSuffix: 'B',
      increment:   1024,
    };

    return {
      min: formatSi(stats.min, opts),
      max: formatSi(stats.max, opts),
      avg: formatSi(stats.avg, opts),
    };;
});
const instanceCpu = computed(() => {
  return toInstanceStats(Object.values(application.value?.deployment?.replicas ?? {}), 'millicpus');
});

// When the application data is loaded set the initial desired instances
const desiredInstances = ref<number>(application?.value?.deployment?.desiredReplicas ?? 0);
watch(application, (newApp) => {
  desiredInstances.value = newApp?.deployment?.desiredReplicas ?? 0;
});

// Watch for changes in the desired instances and trigger the update handler
watch(desiredInstances, (newValue) => {
  onInstancesChange(newValue);
});

// Debounced handler for updating the desired instances
const onInstancesChange = debounce(async (newInstances: number) => {
  if (!application.value) {
    return;
  }

  // If the new instance count matches the current desired replicas, no update is needed
  if (newInstances === application.value.deployment?.desiredReplicas) {
    return;
  }

  const updateRequest: AppUpdateRequest = {
    appChart: application.value.configuration.appChart,
    configurations: application.value.configuration.configurations || [],
    environment: application.value.configuration.environment || {},
    routes: application.value.configuration.routes,
    replaceEnv: true,
    restart: true,
    settings: application.value.configuration.settings || null,
    instances: newInstances
  };

  updateApp({namespace: application.value.meta.namespace, app: application.value.meta.name, body: updateRequest});
}, 500);

async function updateInstances(newInstances: number) {
  desiredInstances.value = newInstances;
}

const showScaleSpinner = computed(() => isUpdatingApp.value);

// Initial git values from the application form data
const sourceType = computed(() => appFormData.value?.source.type);
const gitUsername = computed(() => {
  if (!appFormData.value || !sourceType.value) {
    return '';
  }
  return appFormData.value?.source[sourceType.value as 'github' | 'gitlab']?.userOrOrg;
});
const gitConfig = computed(() => {
  if (!appFormData.value || !sourceType.value) {
    return null;
  }
  return appFormData.value?.source[sourceType.value as 'github' | 'gitlab']?.gitConfig || null;
});

// Fetch git config details if needed for use in git requests
const gitConfigRequestOptions = ref<ResourceQueryOptions>({
  enabled: !!appFormData.value && !!gitConfig.value && (sourceType.value === 'github' || sourceType.value === 'gitlab'),
  polling: false,
});
const {data: selectedGitConfig} = useGitConfig(store, appFormData.value?.source[sourceType.value as 'github' | 'gitlab']?.gitConfig || '', gitConfigRequestOptions);

// Compute the base URL for the selected git provider using the fetched git config
const gitBaseUrl = useGitBaseUrl(sourceType as Ref<'github' | 'gitlab'>, selectedGitConfig);

// Git User
const gitUserRequestOptions = computed<ResourceQueryOptions>(() => ({
  enabled: !!appFormData.value && !!gitBaseUrl.value && !!gitUsername.value,
  polling: false,
}));
const { data: gitUser } = useGitProxyUserType(
  store,
  sourceType as Ref<'github' | 'gitlab'>,
  gitUsername as Ref<string>,
  gitConfig,
  gitBaseUrl as Ref<string>,
  gitUserRequestOptions,
);

// Git Repository
const gitRepo = computed(() => {
  if (!appFormData.value || !sourceType.value) {
    return '';
  }
  return appFormData.value?.source[sourceType.value as 'github' | 'gitlab']?.repository;
});
const gitRepoRequestOptions = computed<ResourceQueryOptions>(() => ({
  enabled: gitBaseUrl.value !== null && !!gitUser.value?.username && !!gitRepo.value,
  polling: false,
}));
const { data: gitRepos } = useGitProxyRepos(
  store,
  sourceType as Ref<'github' | 'gitlab'>,
  gitUser as Ref<{ username: string, userType: string | null }>,
  gitConfig,
  gitBaseUrl as Ref<string>,
  gitRepo as Ref<string>,
  gitRepoRequestOptions,
);
const selectedRepo = computed(() => {
  return gitRepos.value?.find(repo => repo.name === gitRepo.value) || null;
});

// Git Branch
const gitBranch = computed(() => {
  if (!appFormData.value || !sourceType.value) {
    return '';
  }
  return appFormData.value?.source[sourceType.value as 'github' | 'gitlab']?.branch;
});
const gitBranchRequestOptions = computed<ResourceQueryOptions>(() => ({
  enabled: gitBaseUrl.value !== null && !!gitUser.value && !!selectedRepo.value,
  polling: false,
}));
const { data: gitBranches } = useGitProxyBranches(
  store,
  sourceType as Ref<'github' | 'gitlab'>,
  gitUser as Ref<{ username: string, userType: string | null }>,
  gitConfig,
  gitBaseUrl as Ref<string>,
  selectedRepo as Ref<GitProxyGitRepo>,
  gitBranch as Ref<string>,
  gitBranchRequestOptions,
);
const selectedBranch = computed(() => {
  return gitBranches.value?.find(branch => branch.name === gitBranch.value) || null;
})

// Git Commit
const gitCommit = computed(() => {
  if (!appFormData.value || !sourceType.value) {
    return '';
  }
  return appFormData.value?.source[sourceType.value as 'github' | 'gitlab']?.commit;
});
const gitCommitRequestOptions = computed<ResourceQueryOptions>(() => ({
  enabled: gitBaseUrl.value !== null && !!gitUser.value && !!selectedRepo.value && !!selectedBranch.value,
  polling: false,
}));
const { data: gitCommits } = useGitProxyCommits(
  store,
  sourceType as Ref<'github' | 'gitlab'>,
  gitUser as Ref<{ username: string, userType: string | null }>,
  gitConfig,
  gitBaseUrl as Ref<string>,
  selectedRepo as Ref<GitProxyGitRepo>,
  selectedBranch as Ref<GitProxyGitBranch>,
  gitCommitRequestOptions,
);
const selectedCommit = computed(() => {
  return gitCommits.value?.find(commit => commit.sha === gitCommit.value) || null;
});

function formatURL(str: string) {
  const matchGit = str.match('^(https|git)(:\/\/|@)([^\/:]+)[\/:]([^\/:]+)\/(.+)(.git)*$'); // eslint-disable-line no-useless-escape
  return `${matchGit?.[4]}/${matchGit?.[5]}`;
}

// Git commits table columns for display in the UI
const gitCommitsColumns = computed(() => [
  {
    field: 'sha',
    label: t(`epinio.applications.gitSource.${ sourceType.value }.tableHeaders.sha.label`),
    width: '90px',
    sortable: false,
    formatter: (_v: any, row: GitProxyGitCommit) => makeCommitShaCell(
      row,
      application.value?.origin.git?.revision,
      t('epinio.applications.detail.deployment.details.git.deployed')
    )
  },
  {
    field: 'author',
    label: t(`epinio.applications.gitSource.${ sourceType.value }.tableHeaders.author.label`),
    width: '190px',
    sortable: false,
    formatter: (_v: any, row: GitProxyGitCommit) => makeCommitAuthorCell(
      row,
      t(`epinio.applications.gitSource.${ sourceType.value }.tableHeaders.author.unknown`)
    )
  },
  {
    field: 'message',
    label: t(`epinio.applications.gitSource.${ sourceType.value }.tableHeaders.message.label`),
    sortable: false,
  },
  {
    field: 'date',
    label: t(`epinio.applications.gitSource.${ sourceType.value }.tableHeaders.date.label`),
    width: '220px',
    sortable: false,
    formatter: (_v: any, row: GitProxyGitCommit) => {
      const span = document.createElement('span');

      if (row.date) {
        span.textContent = new Date(row.date).toLocaleString();
      }

      return span;
    }
  },
]);

// Git commit table rows for display in the UI
const gitCommitRows = computed(() => {
  if (!gitCommits.value) {
    return [];
  }
  // Add custom namespace delete action to replace the built in rancher shell flow.
  // Gate by namespace write perms so view-only / app-only roles don't see Delete.
  const rows: ResourceTableRow<GitProxyGitCommit>[] = (gitCommits.value ?? []).map((c) => ({
    ...c,
    id: c.sha, // stable, unique per namespace
    availableActions: [{
      label: 'Redeploy',
      action: () => {
        if (!application.value) {
          return;
        }
        appModal.value?.openEdit(application.value, c.commitId)
      },
      enabled: canEditApp.value && !!application.value && c.commitId !== application.value?.origin.git?.revision,
      visible: canEditApp.value && !!application.value && c.commitId !== application.value?.origin.git?.revision,
    }],
  }));
  return rows;
});


function formatDate(date: string, from: boolean) {
  return from ? day(date).fromNow() : day(date).format('DD MMM YYYY');
}

function handleDeleted() {
  // navigate back to the applications list after deletion
  store.$router.push({
    name: 'epinio-c-cluster-applications',
    params: store.$router.currentRoute.params,
  });
}

const appSourceDetails = computed(() => {
  if (!appFormData.value) {
    return null;
  }

  return toAppSourceDetails(appFormData.value, t);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isApplicationLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[8] || (_cache[8] = [
          _createElementVNode("trailhand-loading-spinner", { size: "large" }, null, -1)
        ])))
      : (_unref(isApplicationError))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "Error loading application data: " + _toDisplayString(_unref(applicationError)?.message || 'Error fetching application data'), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h1", null, "Application: " + _toDisplayString(_unref(application)?.meta.name), 1),
                  _cache[9] || (_cache[9] = _createTextVNode()),
                  _createElementVNode("p", null, _toDisplayString(_unref(application)?.stateDisplay), 1)
                ]),
                _cache[10] || (_cache[10] = _createTextVNode()),
                (appAvailableActions.value.length > 0)
                  ? (_openBlock(), _createElementBlock("trailhand-action-menu", {
                      key: 0,
                      actions: appAvailableActions.value
                    }, null, 8, _hoisted_7))
                  : _createCommentVNode("", true)
              ]),
              _cache[11] || (_cache[11] = _createTextVNode()),
              _createElementVNode("h3", null, "Namespace: " + _toDisplayString(_unref(application)?.meta.namespace), 1),
              _cache[12] || (_cache[12] = _createTextVNode()),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(application)?.configuration.routes, (appRoute, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${appRoute}-${index}`
                  }, [
                    (_unref(application)?.status === 'running')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: `${appRoute}-${index}-a`,
                          href: `https://${appRoute}`,
                          target: "_blank",
                          rel: "noopener noreferrer nofollow"
                        }, _toDisplayString(`https://${appRoute}`), 9, _hoisted_8))
                      : (_openBlock(), _createElementBlock("span", {
                          key: `${appRoute}-${index}-b`
                        }, _toDisplayString(`https://${appRoute}`), 1))
                  ]))
                }), 128))
              ])
            ]),
            _cache[47] || (_cache[47] = _createTextVNode()),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("trailhand-card", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(Object.keys(_unref(application)?.configuration.environment || {}).length ?? 0), 1),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('epinio.applications.detail.counts.envVars')), 1)
                  ])
                ])
              ]),
              _cache[13] || (_cache[13] = _createTextVNode()),
              _createElementVNode("trailhand-card", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("p", _hoisted_16, [
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(application)?.configuration.services?.length ?? 0), 1),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('epinio.applications.detail.counts.services')), 1)
                  ])
                ])
              ]),
              _cache[14] || (_cache[14] = _createTextVNode()),
              _createElementVNode("trailhand-card", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("p", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(application)?.configuration.boundConfigurations?.filter(config => config.type === "custom").length ?? 0), 1),
                    _createTextVNode(" " + _toDisplayString(_unref(t)('epinio.applications.detail.counts.config')), 1)
                  ])
                ])
              ])
            ]),
            _cache[48] || (_cache[48] = _createTextVNode()),
            (_unref(application)?.deployment || _unref(application)?.imageUrl)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_22, _toDisplayString(_unref(t)('epinio.applications.detail.deployment.label')), 1))
              : _createCommentVNode("", true),
            _cache[49] || (_cache[49] = _createTextVNode()),
            (_unref(application)?.deployment || _unref(application)?.imageUrl)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createVNode(Tabs, {
                    modelValue: activeDeploymentTab.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeDeploymentTab).value = $event)),
                    tabs: deploymentTabs.value,
                    variant: "underline"
                  }, {
                    overview: _withCtx(() => [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("trailhand-card", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("trailhand-progress-bar", {
                                label: "Instances",
                                value: _unref(application)?.deployment?.readyReplicas,
                                total: desiredInstances.value
                              }, null, 8, _hoisted_28),
                              _cache[20] || (_cache[20] = _createTextVNode()),
                              _createElementVNode("div", _hoisted_29, [
                                (canScaleApp.value)
                                  ? (_openBlock(), _createElementBlock("trailhand-button", {
                                      key: 0,
                                      variant: "secondary",
                                      size: "small",
                                      disabled: _unref(isUpdatingApp) || desiredInstances.value <= 0,
                                      onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (updateInstances(desiredInstances.value - 1)))
                                    }, _cache[15] || (_cache[15] = [
                                      _createElementVNode("trailhand-icon", { name: "minus" }, null, -1)
                                    ]), 40, _hoisted_30))
                                  : _createCommentVNode("", true),
                                _cache[18] || (_cache[18] = _createTextVNode()),
                                (showScaleSpinner.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _cache[16] || (_cache[16] = [
                                      _createElementVNode("i", { class: "icon-spinner animate-spin" }, null, -1)
                                    ])))
                                  : _createCommentVNode("", true),
                                _cache[19] || (_cache[19] = _createTextVNode()),
                                (canScaleApp.value)
                                  ? (_openBlock(), _createElementBlock("trailhand-button", {
                                      key: 2,
                                      variant: "secondary",
                                      size: "small",
                                      disabled: _unref(isUpdatingApp),
                                      onButtonClick: _cache[1] || (_cache[1] = ($event: any) => (updateInstances(desiredInstances.value + 1)))
                                    }, _cache[17] || (_cache[17] = [
                                      _createElementVNode("trailhand-icon", { name: "plus" }, null, -1)
                                    ]), 40, _hoisted_32))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _cache[30] || (_cache[30] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_33, [
                              (showMetricsUnavailable.value)
                                ? (_openBlock(), _createBlock(Banner, {
                                    key: 0,
                                    color: "warning",
                                    class: "metrics-unavailable"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('epinio.intro.metrics.notAvailable')), 1)
                                    ]),
                                    _: 1
                                  }))
                                : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("table", _hoisted_35, [
                                      _cache[28] || (_cache[28] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("th"),
                                          _createTextVNode(),
                                          _createElementVNode("th", null, "Min"),
                                          _createTextVNode(),
                                          _createElementVNode("th", null, "Max"),
                                          _createTextVNode(),
                                          _createElementVNode("th", null, "Avg")
                                        ])
                                      ], -1)),
                                      _cache[29] || (_cache[29] = _createTextVNode()),
                                      _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("td", null, _toDisplayString(_unref(t)('tableHeaders.memory')), 1),
                                          _cache[21] || (_cache[21] = _createTextVNode()),
                                          _createElementVNode("td", null, _toDisplayString(instanceMemory.value.min), 1),
                                          _cache[22] || (_cache[22] = _createTextVNode()),
                                          _createElementVNode("td", null, _toDisplayString(instanceMemory.value.max), 1),
                                          _cache[23] || (_cache[23] = _createTextVNode()),
                                          _createElementVNode("td", null, _toDisplayString(instanceMemory.value.avg), 1)
                                        ]),
                                        _cache[27] || (_cache[27] = _createTextVNode()),
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("td", null, _toDisplayString(_unref(t)('tableHeaders.cpu')), 1),
                                          _cache[24] || (_cache[24] = _createTextVNode()),
                                          _createElementVNode("td", null, _toDisplayString(instanceCpu.value.min), 1),
                                          _cache[25] || (_cache[25] = _createTextVNode()),
                                          _createElementVNode("td", null, _toDisplayString(instanceCpu.value.max), 1),
                                          _cache[26] || (_cache[26] = _createTextVNode()),
                                          _createElementVNode("td", null, _toDisplayString(instanceCpu.value.avg), 1)
                                        ])
                                      ])
                                    ])
                                  ]))
                            ])
                          ])
                        ]),
                        _cache[40] || (_cache[40] = _createTextVNode()),
                        (appSourceDetails.value)
                          ? (_openBlock(), _createElementBlock("trailhand-card", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("table", null, [
                                  _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_38, _toDisplayString(_unref(t)('epinio.applications.detail.deployment.details.origin')), 1),
                                      _cache[31] || (_cache[31] = _createTextVNode()),
                                      _createElementVNode("td", _hoisted_39, _toDisplayString(appSourceDetails.value.label), 1)
                                    ]),
                                    _cache[36] || (_cache[36] = _createTextVNode()),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appSourceDetails.value.details, (d) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: d.label
                                      }, [
                                        _createElementVNode("td", _hoisted_40, _toDisplayString(d.label), 1),
                                        _cache[32] || (_cache[32] = _createTextVNode()),
                                        (d.value && d.value.startsWith('http'))
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_41, [
                                              _createElementVNode("a", {
                                                href: d.value,
                                                target: "_blank",
                                                class: "origin-link"
                                              }, _toDisplayString(formatURL(d.value)), 9, _hoisted_42)
                                            ]))
                                          : (selectedCommit.value && d.value && d.value.match(/^[a-f0-9]{40}$/))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_43, [
                                                _createElementVNode("a", {
                                                  href: `${selectedCommit.value.htmlUrl}/commit/${d.value}`,
                                                  target: "_blank",
                                                  class: "origin-link"
                                                }, _toDisplayString(d.value), 9, _hoisted_44)
                                              ]))
                                            : (_openBlock(), _createElementBlock("td", _hoisted_45, _toDisplayString(d.value), 1))
                                      ]))
                                    }), 128)),
                                    _cache[37] || (_cache[37] = _createTextVNode()),
                                    (selectedRepo.value && selectedRepo.value.createdAt)
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_46, [
                                          _createElementVNode("td", _hoisted_47, _toDisplayString(_unref(t)('epinio.applications.detail.deployment.details.git.created')), 1),
                                          _cache[33] || (_cache[33] = _createTextVNode()),
                                          _createElementVNode("td", _hoisted_48, _toDisplayString(formatDate(selectedRepo.value.createdAt, false)), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _cache[38] || (_cache[38] = _createTextVNode()),
                                    (selectedRepo.value && (selectedRepo.value.updatedAt || selectedRepo.value.lastActivityAt))
                                      ? (_openBlock(), _createElementBlock("tr", _hoisted_49, [
                                          _createElementVNode("td", _hoisted_50, _toDisplayString(_unref(t)('epinio.applications.detail.deployment.details.git.updated')), 1),
                                          _cache[34] || (_cache[34] = _createTextVNode()),
                                          _createElementVNode("td", _hoisted_51, _toDisplayString(formatDate(selectedRepo.value.updatedAt || selectedRepo.value.lastActivityAt || '', true)), 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _cache[39] || (_cache[39] = _createTextVNode()),
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("td", _hoisted_52, _toDisplayString(_unref(t)('epinio.applications.tableHeaders.deployedBy')), 1),
                                      _cache[35] || (_cache[35] = _createTextVNode()),
                                      _createElementVNode("td", _hoisted_53, _toDisplayString(_unref(application).deployment?.username), 1)
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    gitCommits: _withCtx(() => [
                      _createVNode(Banner, {
                        color: "info",
                        class: "redeploy-info"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('epinio.applications.detail.deployment.commits.redeploy')), 1)
                        ]),
                        _: 1
                      }),
                      _cache[41] || (_cache[41] = _createTextVNode()),
                      (_unref(gitCommits) && _unref(gitCommits).length)
                        ? (_openBlock(), _createElementBlock("trailhand-table", {
                            key: 0,
                            ref: (el) => { if (el) el.renderActions = _unref(makeActionMenu); },
                            rows: gitCommitRows.value,
                            columns: gitCommitsColumns.value,
                            "key-field": "sha",
                            searchable: true,
                            paginated: true,
                            "rows-per-page": 10
                          }, null, 8, _hoisted_54))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1,
                    __: [42]
                  }, 8, ["modelValue", "tabs"])
                ]))
              : _createCommentVNode("", true),
            _cache[50] || (_cache[50] = _createTextVNode()),
            _createElementVNode("h3", _hoisted_55, _toDisplayString(_unref(t)('epinio.applications.detail.tables.label')), 1),
            _cache[51] || (_cache[51] = _createTextVNode()),
            _createElementVNode("div", null, [
              _createVNode(Tabs, {
                modelValue: activeResourceTab.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((activeResourceTab).value = $event)),
                tabs: resourceTabs.value,
                variant: "underline"
              }, {
                instances: _withCtx(() => [
                  _createElementVNode("trailhand-table", {
                    ref: (el) => { if (el) el.renderActions = _unref(makeActionMenu); },
                    columns: instanceColumns,
                    rows: instanceRows.value,
                    searchable: false,
                    paginated: false
                  }, null, 8, _hoisted_56)
                ]),
                services: _withCtx(() => [
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("trailhand-text-input", {
                      value: servicesSearchQuery.value,
                      placeholder: "Search...",
                      onTextInputChange: _cache[3] || (_cache[3] = (e) => servicesSearchQuery.value = e.detail.value)
                    }, null, 40, _hoisted_58)
                  ]),
                  _cache[43] || (_cache[43] = _createTextVNode()),
                  _createElementVNode("trailhand-table", {
                    ref: (el) => { if (el) el.renderActions = _unref(makeActionMenu); },
                    rows: displayServiceRows.value,
                    columns: serviceColumns,
                    searchable: false,
                    "server-side": true,
                    "total-items": _unref(services)?.totalItems ?? 0,
                    "current-page": servicesRequestParams.value.page,
                    loading: _unref(isLoadingServices),
                    "key-field": "id",
                    onPageChange: _cache[4] || (_cache[4] = (e) => { servicesRequestParams.value.page = e.detail.page; })
                  }, null, 40, _hoisted_59)
                ]),
                configs: _withCtx(() => [
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("trailhand-text-input", {
                      value: configurationsSearchQuery.value,
                      placeholder: "Search...",
                      onTextInputChange: _cache[5] || (_cache[5] = (e) => configurationsSearchQuery.value = e.detail.value)
                    }, null, 40, _hoisted_61)
                  ]),
                  _cache[44] || (_cache[44] = _createTextVNode()),
                  _createElementVNode("trailhand-table", {
                    ref: (el) => { if (el) el.renderActions = _unref(makeActionMenu); },
                    rows: displayConfigurationRows.value,
                    columns: configurationColumns,
                    searchable: false,
                    "server-side": true,
                    "total-items": _unref(configurations)?.totalItems ?? 0,
                    "current-page": configurationsRequestParams.value.page,
                    loading: _unref(isLoadingConfigurations),
                    "key-field": "id",
                    onPageChange: _cache[6] || (_cache[6] = (e) => { configurationsRequestParams.value.page = e.detail.page; })
                  }, null, 40, _hoisted_62)
                ]),
                _: 1,
                __: [45,46]
              }, 8, ["modelValue", "tabs"])
            ])
          ])),
    _cache[52] || (_cache[52] = _createTextVNode()),
    _createVNode(ServiceInstanceModal, {
      ref_key: "serviceModal",
      ref: serviceModal
    }, null, 512),
    _cache[53] || (_cache[53] = _createTextVNode()),
    _createVNode(ServiceDeleteModal, {
      ref_key: "serviceDeleteModal",
      ref: serviceDeleteModal
    }, null, 512),
    _cache[54] || (_cache[54] = _createTextVNode()),
    _createVNode(ConfigurationModal, {
      ref_key: "configModal",
      ref: configModal
    }, null, 512),
    _cache[55] || (_cache[55] = _createTextVNode()),
    _createVNode(ConfigurationDeleteModal, {
      ref_key: "configDeleteModal",
      ref: configDeleteModal
    }, null, 512),
    _cache[56] || (_cache[56] = _createTextVNode()),
    _createVNode(AppModal, {
      ref_key: "appModal",
      ref: appModal
    }, null, 512),
    _cache[57] || (_cache[57] = _createTextVNode()),
    _createVNode(ExportAppModal, {
      ref_key: "exportAppModal",
      ref: exportAppModal
    }, null, 512),
    _cache[58] || (_cache[58] = _createTextVNode()),
    _createVNode(AppDeleteModal, {
      ref_key: "appDeleteModal",
      ref: appDeleteModal,
      onDeleted: handleDeleted
    }, null, 512)
  ], 64))
}
}

})